// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"49":"saipa","99":"veniran","177":"home","507":"ikco"}[chunkId] || chunkId) + "." + {"11":"e4d9229f","49":"9994b8ca","99":"d8dab25e","177":"3bab8684","507":"3dbb05da"}[chunkId] + ".js";
};